export default __webpack_public_path__ + "static/media/vinyasa2.2676d21b.JPG";